import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

function SingleImage({ image, title }) {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    
  return (
    <div className='imageGallery_div' data-aos="fade-up">
      <img src={image && image} alt='gallery_img' loading='lazy' onClick={handleClickOpen}/>

      <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <div className='eventCard_img_modal'>
              <img src={image && image} alt="gallery_img" loading='lazy'/>
            </div>
          </DialogContent>
      </Dialog>
  </div>
    )
}

export default SingleImage